<template>
  <div>
    <div class="c4-user">
      <span class="c4-av">{{ initials }}</span>
      <div>
        <b>{{ name }}</b>
        <span>{{ sub }}</span>
      </div>
    </div>
    <nav class="c4-nav" :aria-label="tx('menu.title')">
      <button type="button" data-fk="m-settings" @click="$emit('settings')">
        <i class="mdi mdi-cog-outline" aria-hidden="true"></i>{{ tx("menu.settings") }}
      </button>
      <button v-if="fullscreenSupported" type="button" data-fk="m-fs" @click="$emit('fullscreen')">
        <i class="mdi" :class="fullscreenOn ? 'mdi-fullscreen-exit' : 'mdi-fullscreen'" aria-hidden="true"></i>
        {{ fullscreenOn ? tx("menu.fullscreen_exit") : tx("menu.fullscreen") }}
      </button>
      <button
        v-for="r in routes"
        :key="r.name"
        type="button"
        :class="{ on: r.name === current }"
        :data-fk="'m-' + r.name"
        @click="$emit('go', r.name)"
      >
        <i class="mdi" :class="r.icon" aria-hidden="true"></i>{{ $t(r.displayName) }}
      </button>
      <button type="button" data-fk="m-logout" @click="$emit('logout')">
        <i class="mdi mdi-logout" aria-hidden="true"></i>{{ tx("menu.logout") }}
      </button>
    </nav>
  </div>
</template>

<script>
import canteenV4Text from "@/mixins/canteenV4Text";

export default {
  name: "CanteenMenuSheet",
  mixins: [canteenV4Text],
  props: {
    user: { type: Object, default: null },
    company: { type: Object, default: null },
    // stranice koje korisnik smije da vidi (isti izvor kao PaymentDrawer: allRoutes + isRouteAvailable)
    routes: { type: Array, default: () => [] },
    current: { type: String, default: "" },
    fullscreenSupported: { type: Boolean, default: false },
    fullscreenOn: { type: Boolean, default: false },
  },
  computed: {
    name() {
      if (!this.user) return "";
      return `${this.toLatin(this.user.name)} ${this.toLatin(this.user.lastname)}`.trim() || this.user.email || "";
    },
    initials() {
      if (!this.user) return "";
      const a = (this.user.name || "").trim().charAt(0);
      const b = (this.user.lastname || "").trim().charAt(0);
      return this.toLatin((a + b).toUpperCase()) || "·";
    },
    sub() {
      const r = this.company && this.company.restaurant && this.company.restaurant.name;
      return [this.company && this.toLatin(this.company.name), r && this.toLatin(r)].filter(Boolean).join(" · ");
    },
  },
};
</script>
